<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>Version Management System</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
<div sxPadding="medium medium 10% medium" sxCol sxGap="10px" *ngIf="appVms">


    <ion-accordion-group>
      <ion-accordion value="first">
        <ion-item slot="header" color="light">
          <ion-label>Running</ion-label>
          <ion-label slot="end" *ngIf="appVms.restartLog?.length > 0 && appVms.restartLog[0]"
          >Build #{{ appVms.restartLog[0]?.buildNumber }} - Started
            {{ appVms.restartLog[0].createTime | date }}</ion-label
          >
        </ion-item>
        <div slot="content">
          <div class="log-view" *ngFor="let log of appVms.restartLog">
            <p>#{{ log.buildNumber }}</p>
            <p>{{ log.createTime | date : 'MMM d, h:mm a' }}</p>
          </div>
        </div>
      </ion-accordion>
      <ion-accordion value="second">
        <ion-item slot="header" color="light">
          <ion-label>Build History</ion-label>
          <ion-label slot="end" *ngIf="appVms?.buildLogs?.length>0 && appVms?.buildLogs[0]"
          >Latest Build: #{{ appVms.buildLogs[0]?.buildNumber }} - Built:
            {{ appVms.buildLogs[0]?.createTime }}</ion-label
          >
        </ion-item>
        <div slot="content" *ngIf="appVms?.buildLogs">
          <div class="log-view" *ngFor="let log of appVms.buildLogs">
            <p>#{{ log.buildNumber }}</p>
            <p>{{ log.createTime | date : 'MMM d, h:mm a' }}</p>
          </div>
        </div>
      </ion-accordion>
    </ion-accordion-group>

    <div sxRow sxGap="10px">
      <ion-list sxWidth="fill">
        <ion-list-header>
          <ion-label>Android</ion-label>
        </ion-list-header>
        <ion-item *ngFor="let provider of authProviders">
          <ion-label>{{ provider }}</ion-label>
          <ion-toggle [(ngModel)]="appVms.androidAuth[provider]"></ion-toggle>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Minimum Version</ion-label>
          <ion-input [(ngModel)]="appVms.androidPrefs.minimumVersion"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Latest Version</ion-label>
          <ion-input [(ngModel)]="appVms.androidPrefs.latestVersion"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label>Lock Platform</ion-label>
          <ion-toggle [(ngModel)]="appVms.androidPrefs.lockPlatform"></ion-toggle>
        </ion-item>
      </ion-list>

      <ion-list sxWidth="fill">
        <ion-list-header>
          <ion-label>iOS</ion-label>
        </ion-list-header>
        <ion-item *ngFor="let provider of authProviders">
          <ion-label>{{ provider }}</ion-label>
          <ion-toggle [(ngModel)]="appVms.iosAuth[provider]"></ion-toggle>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Minimum Version</ion-label>
          <ion-input [(ngModel)]="appVms.iosPrefs.minimumVersion"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Latest Version</ion-label>
          <ion-input [(ngModel)]="appVms.iosPrefs.latestVersion"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label>Lock Platform</ion-label>
          <ion-toggle [(ngModel)]="appVms.iosPrefs.lockPlatform"></ion-toggle>
        </ion-item>
      </ion-list>

      <ion-list sxWidth="fill">
        <ion-list-header>
          <ion-label>QR Scanner Web</ion-label>
        </ion-list-header>
        <ion-item *ngFor="let provider of authProviders">
          <ion-label>{{ provider }}</ion-label>
          <ion-toggle
            [(ngModel)]="appVms.webAuthProviders[provider]"></ion-toggle>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Minimum Version</ion-label>
          <ion-input [(ngModel)]="appVms.qrScannerPrefs.minimumVersion"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Latest Version</ion-label>
          <ion-input [(ngModel)]="appVms.qrScannerPrefs.latestVersion"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label>Lock Platform</ion-label>
          <ion-toggle [(ngModel)]="appVms.qrScannerPrefs.lockPlatform"></ion-toggle>
        </ion-item>
      </ion-list>
    </div>

    <ion-item>
      <ion-label>Allow User Profile Verification</ion-label>
      <ion-toggle
        [(ngModel)]="appVms.allowUserProfileVerification"></ion-toggle>
    </ion-item>

    <ion-item>
      <ion-label position="stacked">Maintenance Message</ion-label>
      <ion-textarea [(ngModel)]="appVms.maintenanceMessage"></ion-textarea>
    </ion-item>



</div>
  <page-action>
    <super-button [action]="update">Update</super-button>
  </page-action>
</ion-content>
